import "core-js/modules/es.promise.finally.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.reduce.js";
import React__default, { createContext, useContext, useState, useEffect, useRef, useCallback, useMemo, useLayoutEffect } from 'react';
import { useClient, useQuery, useSubscription } from 'urql';
import jsCookie from 'js-cookie';
import decode from 'querystring-es3/decode';
import encode from 'querystring-es3/encode';
import jwtDecode from 'jwt-decode';
import { trigger, accessTokenUpdatedEvent, logoutEvent, useEventListener, Events, termsAcceptedEvent, emailVerifiedEvent } from '@dinotechltd/events';
import { pipe, mergeMap, fromPromise, map } from 'wonka';
import { useLocation, navigate as navigate$1 } from '@reach/router';
import { isMobile, isTablet, isMobileOnly, isIOS, isWinPhone, isAndroid } from '@dinotechltd/device-detect';
import { navigate } from 'gatsby';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _createForOfIteratorHelperLoose(o) {
  var i = 0;

  if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
    if (Array.isArray(o) || (o = _unsupportedIterableToArray(o))) return function () {
      if (i >= o.length) return {
        done: true
      };
      return {
        done: false,
        value: o[i++]
      };
    };
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  i = o[Symbol.iterator]();
  return i.next.bind(i);
}

var defaultConfig = {
  translations: {},
  currencies: {},
  getTranslation: function getTranslation() {
    return '';
  },
  getCurrencySymbol: function getCurrencySymbol() {
    return '';
  },
  getLicense: function getLicense() {
    return '';
  },
  CASINO: {
    path: ''
  },
  LIVE_CASINO: {
    path: ''
  },
  DEPOSIT: {
    path: ''
  },
  SIGN_UP: {
    path: ''
  },
  QUICK_DEPOSIT_SIGN_IN: {
    path: ''
  },
  ENTER_CODE: {
    path: ''
  },
  ENTER_CODE_DEPOSIT: {
    path: ''
  },
  LOBBY: {
    path: ''
  },
  SIGN_IN: {
    path: ''
  },
  PROFILE: {
    path: ''
  },
  WITHDRAWAL: {
    path: ''
  },
  HOME: {
    path: ''
  },
  TERMS_AND_CONDITIONS: {
    path: ''
  },
  NOT_LOGGED_IN: {
    path: ''
  },
  ADDITIONAL_INFORMATION: {
    path: ''
  },
  RECEIPT: {
    path: ''
  }
};
var ConfigContext = /*#__PURE__*/createContext(defaultConfig);

function dataToConfig(data) {
  var _data$licenseConfig$l;

  if (!data.translationConfig) {
    console.error('No config data recieved');
    return defaultConfig;
  }

  var license = (_data$licenseConfig$l = data.licenseConfig.license[0]) === null || _data$licenseConfig$l === void 0 ? void 0 : _data$licenseConfig$l.n[0].license;
  var groupedCurrencies = data.currenciesConfig.currencies;

  var translationConfig = data.translationConfig,
      paths = _objectWithoutPropertiesLoose(data, ["translationConfig"]);

  var groupedTranslations = translationConfig.translations;
  var translations = groupedTranslations.map(function (translationsNode) {
    var _ref;

    var translation = translationsNode.n.find(function (translationNode) {
      return typeof translationNode.d === 'string';
    });
    return translation ? (_ref = {}, _ref[translation.t] = translation.d, _ref) : {};
  });
  var currencies = groupedCurrencies.map(function (currenciesNode) {
    var _ref2;

    var currency = currenciesNode.n.find(function (currenciesNode) {
      return typeof currenciesNode.v === 'string';
    });
    return currency ? (_ref2 = {}, _ref2[currency.v] = currency.s, _ref2) : {};
  });
  var currenciesObject = Object.assign.apply(Object, [{}].concat(currencies));
  var translationsObject = Object.assign.apply(Object, [{}].concat(translations));
  return _extends(_extends({}, paths), {}, {
    translations: translationsObject,
    currencies: currenciesObject,
    getTranslation: function getTranslation(key) {
      if (!translationsObject[key]) {
        console.error("No translation for key: " + key);
      }

      return translationsObject[key] || '';
    },
    getLicense: function getLicense() {
      return license;
    },
    getCurrencySymbol: function getCurrencySymbol(key) {
      return currenciesObject[key] || null;
    }
  });
}

var useConfigContext = function useConfigContext() {
  return useContext(ConfigContext);
};

function useDinoMutation(query, opts) {
  var client = useClient();

  var _useState = useState(false),
      loading = _useState[0],
      setLoading = _useState[1];

  var mutate = function mutate(variables) {
    setLoading(true);
    return client.mutation(query, variables).toPromise().then(function (result) {
      setLoading(false);

      if (result.error) {
        if (opts.onError) opts.onError(result.error);
      } else if (result.data) {
        if (opts.onCompleted) opts.onCompleted(result.data);
      }

      return result;
    });
  };

  return [mutate, {
    loading: loading
  }];
}

function useDinoQuery(query, opts) {
  var _useQuery = useQuery({
    query: query,
    pause: opts.skip,
    variables: opts.variables,
    requestPolicy: opts.requestPolicy
  }),
      _useQuery$ = _useQuery[0],
      fetching = _useQuery$.fetching,
      data = _useQuery$.data,
      error = _useQuery$.error,
      refetch = _useQuery[1];

  useEffect(function () {
    if (!fetching && error && opts.onError) {
      opts.onError && opts.onError(error);
    }
  }, [fetching, error]);
  return {
    loading: fetching,
    data: data,
    error: error,
    refetch: refetch
  };
}

function decodeQs(search) {
  return decode(search.startsWith("?") ? search.substr(1) : search);
}

function encodeQs(map) {
  return encode(map);
}

function getCurrentQueryParams() {
  var queryParams = typeof window !== 'undefined' ? window.location.search : '';
  return decodeQs(queryParams);
}

function addParamsToUrl(url, params) {
  return url + (url.indexOf('?') >= 0 ? '&' : '?') + encodeQs(params);
}

var ACCESS_TOKEN_COOKIE_NAME = 'accessToken';
var REFRESH_TOKEN_COOKIE_NAME = 'refreshToken';
var GAME_PLAY_STARTED_AT = 'gameInit';
var COOKIE_ATTRS = {
  secure: true,
  path: '/',
  sameSite: 'lax'
};

var removeAccessTokens = function removeAccessTokens(cookieAttrs) {
  removeAccessToken(cookieAttrs);
  removeRefreshToken(cookieAttrs);
  removeRealityCheckTokens(cookieAttrs);
};

var removeAccessToken = function removeAccessToken(cookieAttrs) {
  jsCookie.remove(ACCESS_TOKEN_COOKIE_NAME, _extends(_extends({}, COOKIE_ATTRS), cookieAttrs));
  trigger(accessTokenUpdatedEvent(undefined));
};

var removeRefreshToken = function removeRefreshToken(cookieAttrs) {
  jsCookie.remove(REFRESH_TOKEN_COOKIE_NAME, _extends(_extends({}, COOKIE_ATTRS), cookieAttrs));
};

var removeRealityCheckTokens = function removeRealityCheckTokens(cookieAttrs) {
  jsCookie.remove(GAME_PLAY_STARTED_AT, _extends(_extends({}, COOKIE_ATTRS), cookieAttrs));
};

function validateToken(token) {
  if (!token) {
    return undefined;
  }

  try {
    jwtDecode(token);
    return token;
  } catch (_unused) {
    return undefined;
  }
} // We do not allow an access token without a refresh token so first
// we make sure that the refresh token is present


var getAccessToken = function getAccessToken() {
  if (!getRefreshToken()) {
    return undefined;
  }

  return validateToken(jsCookie.get(ACCESS_TOKEN_COOKIE_NAME));
};

var getRefreshToken = function getRefreshToken() {
  return validateToken(jsCookie.get(REFRESH_TOKEN_COOKIE_NAME));
};

function updateAccessToken(accessToken, cookieAttrs) {
  jsCookie.set(ACCESS_TOKEN_COOKIE_NAME, accessToken, _extends(_extends({}, COOKIE_ATTRS), cookieAttrs));
  trigger(accessTokenUpdatedEvent(accessToken));
}

function updateRefreshToken(refreshToken, cookieAttrs) {
  jsCookie.set(REFRESH_TOKEN_COOKIE_NAME, refreshToken, _extends(_extends({}, COOKIE_ATTRS), cookieAttrs));
}

function updateTokensFromQueryString(cookieAttrs) {
  var _getCurrentQueryParam = getCurrentQueryParams(),
      accessToken = _getCurrentQueryParam.accessToken,
      refreshToken = _getCurrentQueryParam.refreshToken;

  if (accessToken && refreshToken) {
    updateAccessToken(String(accessToken), cookieAttrs);
    updateRefreshToken(String(refreshToken), cookieAttrs);
  }
}

var useTimeout = function useTimeout(callback, // function to call. No args passed.
// if you create a new callback each render, then previous callback will be cancelled on render.
timeout) {
  if (timeout === void 0) {
    timeout = 0;
  }

  var timeoutIdRef = useRef();
  var cancel = useCallback(function () {
    var timeoutId = timeoutIdRef.current;

    if (timeoutId) {
      timeoutIdRef.current = undefined;
      clearTimeout(timeoutId);
    }
  }, [timeoutIdRef]);
  useEffect(function () {
    timeoutIdRef.current = setTimeout(callback, timeout);
    return cancel;
  }, [callback, timeout, cancel]);
  return cancel;
};

var ERROR_TEMPLATE = 'GraphQL error: ';
var ErrorType;

(function (ErrorType) {
  ErrorType["IncorrectPhoneNumberFailure"] = "IncorrectPhoneNumberFailure";
  ErrorType["EmailAlreadyExistsFailure"] = "EmailAlreadyExistsFailure";
  ErrorType["NotAllowedToPlayOrDepositOrWithdrawFailure"] = "NotAllowedToPlayOrDepositOrWithdrawFailure";
  ErrorType["NotAllowedAlreadySelfExcludedFailure"] = "NotAllowedAlreadySelfExcludedFailure";
  ErrorType["InvalidLoginCodeFailure"] = "InvalidLoginCodeFailure";
  ErrorType["MaxInvalidLoginCodeAttemptsFailure"] = "MaxInvalidLoginCodeAttemptsFailure";
  ErrorType["AccountClosedFailure"] = "AccountClosedFailure";
  ErrorType["NotActivePlayerSessionFailure"] = "NotActivePlayerSessionFailure";
  ErrorType["PlayerAccountPermanentlyClosed"] = "PlayerAccountPermanentlyClosed";
  ErrorType["InvalidOrExpiredTokenFailure"] = "InvalidOrExpiredTokenFailure";
  ErrorType["ForbiddenCountryFailure"] = "ForbiddenCountryFailure";
  ErrorType["UnsafeConnectionFailure"] = "UnsafeConnectionFailure";
})(ErrorType || (ErrorType = {}));

var getFirstGraphQLErrorType = function getFirstGraphQLErrorType(error) {
  var _error$graphQLErrors$, _error$graphQLErrors$2;

  return (_error$graphQLErrors$ = error.graphQLErrors[0]) === null || _error$graphQLErrors$ === void 0 ? void 0 : (_error$graphQLErrors$2 = _error$graphQLErrors$.extensions) === null || _error$graphQLErrors$2 === void 0 ? void 0 : _error$graphQLErrors$2.type;
};

var getGraphQLErrorType = function getGraphQLErrorType(error) {
  var _error$extensions;

  return (_error$extensions = error.extensions) === null || _error$extensions === void 0 ? void 0 : _error$extensions.type;
};

var getMutationErrorMessage = function getMutationErrorMessage(error) {
  var baseMessage = error.message;
  return baseMessage.includes(ERROR_TEMPLATE) ? baseMessage.replace(ERROR_TEMPLATE, '') : baseMessage;
};

function handleError(onError, handledTypes) {
  if (onError === void 0) {
    onError = undefined;
  }

  if (handledTypes === void 0) {
    handledTypes = [];
  }

  return function (error) {
    for (var _iterator = _createForOfIteratorHelperLoose(error.graphQLErrors), _step; !(_step = _iterator()).done;) {
      var graphQLError = _step.value;
      var type = getGraphQLErrorType(graphQLError);

      for (var _iterator2 = _createForOfIteratorHelperLoose(handledTypes), _step2; !(_step2 = _iterator2()).done;) {}

      onError && onError(type || 'GenericError');
    }
  };
}

function hasError(error, errorType) {
  for (var _iterator3 = _createForOfIteratorHelperLoose(error.graphQLErrors), _step3; !(_step3 = _iterator3()).done;) {
    var graphQLError = _step3.value;

    if (getGraphQLErrorType(graphQLError) === errorType) {
      return true;
    }
  }

  return false;
}

var LOGOUT = {
  "kind": "Document",
  "definitions": [{
    "kind": "OperationDefinition",
    "operation": "mutation",
    "name": {
      "kind": "Name",
      "value": "Logout"
    },
    "variableDefinitions": [],
    "directives": [],
    "selectionSet": {
      "kind": "SelectionSet",
      "selections": [{
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "logout"
        },
        "arguments": [],
        "directives": [],
        "selectionSet": {
          "kind": "SelectionSet",
          "selections": [{
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "loggedOut"
            },
            "arguments": [],
            "directives": []
          }]
        }
      }]
    }
  }],
  "loc": {
    "start": 0,
    "end": 34,
    "source": {
      "body": "mutation Logout{logout{loggedOut}}",
      "name": "GraphQL request",
      "locationOffset": {
        "line": 1,
        "column": 1
      }
    }
  }
};
var LogoutReason;

(function (LogoutReason) {
  LogoutReason["SESSION_EXPIRED"] = "SESSION_EXPIRED";
  LogoutReason["LOGGED_IN_FROM_ANOTHER_DEVICE"] = "LOGGED_IN_FROM_ANOTHER_DEVICE";
  LogoutReason["TNC_DECLINED"] = "TNC_DECLINED";
  LogoutReason["REGULAR_LOGOUT"] = "REGULAR_LOGOUT";
  LogoutReason["REALITY_CHECK_LOGOUT"] = "REALITY_CHECK_LOGOUT";
  LogoutReason["JWT_EXPIRED"] = "JWT_EXPIRED";
})(LogoutReason || (LogoutReason = {}));

function useLogout(reason, exitPath) {
  var _useDinoMutation = useDinoMutation(LOGOUT, {
    onError: handleError(),
    onCompleted: function onCompleted() {
      trigger(logoutEvent(reason, exitPath));
    }
  }),
      logout = _useDinoMutation[0],
      loading = _useDinoMutation[1].loading;

  return {
    logout: logout,
    loggingOut: loading
  };
}

var getOrRefreshAccessToken = function getOrRefreshAccessToken(client, cookieAttrs) {
  try {
    var _exit4 = false;
    var token = getAccessToken();

    if (!token) {
      return Promise.resolve(undefined);
    }

    var _jwtDecode = jwtDecode(token),
        exp = _jwtDecode.exp;

    var threshold = 60 * 1000;
    var expired = new Date(exp * 1000 - threshold) < new Date();

    var _temp6 = function () {
      if (expired) {
        return Promise.resolve(refreshTokens(client, cookieAttrs)).then(function (_ref4) {
          var accessToken = _ref4.accessToken;
          _exit4 = true;
          return accessToken;
        });
      }
    }();

    return Promise.resolve(_temp6 && _temp6.then ? _temp6.then(function (_result3) {
      return _exit4 ? _result3 : token;
    }) : _exit4 ? _temp6 : token);
  } catch (e) {
    return Promise.reject(e);
  }
};

var REFRESH_ACCESS_TOKEN = {
  "kind": "Document",
  "definitions": [{
    "kind": "OperationDefinition",
    "operation": "mutation",
    "name": {
      "kind": "Name",
      "value": "RefreshAccessToken"
    },
    "variableDefinitions": [{
      "kind": "VariableDefinition",
      "variable": {
        "kind": "Variable",
        "name": {
          "kind": "Name",
          "value": "refreshToken"
        }
      },
      "type": {
        "kind": "NonNullType",
        "type": {
          "kind": "NamedType",
          "name": {
            "kind": "Name",
            "value": "String"
          }
        }
      },
      "directives": []
    }],
    "directives": [],
    "selectionSet": {
      "kind": "SelectionSet",
      "selections": [{
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "refreshAccessToken"
        },
        "arguments": [{
          "kind": "Argument",
          "name": {
            "kind": "Name",
            "value": "refreshToken"
          },
          "value": {
            "kind": "Variable",
            "name": {
              "kind": "Name",
              "value": "refreshToken"
            }
          }
        }],
        "directives": [],
        "selectionSet": {
          "kind": "SelectionSet",
          "selections": [{
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "accessToken"
            },
            "arguments": [],
            "directives": []
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "refreshToken"
            },
            "arguments": [],
            "directives": []
          }]
        }
      }]
    }
  }],
  "loc": {
    "start": 0,
    "end": 124,
    "source": {
      "body": "mutation RefreshAccessToken($refreshToken:String!){refreshAccessToken(refreshToken:$refreshToken){accessToken refreshToken}}",
      "name": "GraphQL request",
      "locationOffset": {
        "line": 1,
        "column": 1
      }
    }
  }
};

var refreshTokens = function refreshTokens(client, cookieAttrs) {
  try {
    var _temp3 = function _temp3(_result2) {
      return _exit2 ? _result2 : {};
    };

    var _exit2 = false;
    var refreshToken = getRefreshToken();

    var _temp4 = function () {
      if (refreshToken) {
        removeRefreshToken(cookieAttrs);
        return function () {
          if (typeof window !== 'undefined') {
            var sessionExpired = function sessionExpired() {
              trigger(logoutEvent(LogoutReason.JWT_EXPIRED));
              return {};
            };

            return Promise.resolve(client.mutation(REFRESH_ACCESS_TOKEN, {
              refreshToken: refreshToken
            }).toPromise()).then(function (_ref) {
              var data = _ref.data,
                  error = _ref.error;

              if (data) {
                var _data$refreshAccessTo, _data$refreshAccessTo2;

                var accessToken = data === null || data === void 0 ? void 0 : (_data$refreshAccessTo = data.refreshAccessToken) === null || _data$refreshAccessTo === void 0 ? void 0 : _data$refreshAccessTo.accessToken;
                var newRefreshToken = data === null || data === void 0 ? void 0 : (_data$refreshAccessTo2 = data.refreshAccessToken) === null || _data$refreshAccessTo2 === void 0 ? void 0 : _data$refreshAccessTo2.refreshToken;

                if (accessToken && newRefreshToken) {
                  updateAccessToken(accessToken, cookieAttrs);
                  updateRefreshToken(newRefreshToken, cookieAttrs);
                  _exit2 = true;
                  return {
                    accessToken: accessToken,
                    refreshToken: refreshToken
                  };
                } else {
                  _exit2 = true;
                  return sessionExpired();
                }
              } else if (error === null || error === void 0 ? void 0 : error.graphQLErrors) {
                var graphQLErrors = error.graphQLErrors;

                if (graphQLErrors) {
                  graphQLErrors.forEach(function (_ref2) {
                    var extensions = _ref2.extensions;
                    var type = extensions === null || extensions === void 0 ? void 0 : extensions.type;

                    switch (type) {
                      case 'InvalidTokenFailure':
                        removeAccessTokens(cookieAttrs);
                        break;
                    }
                  });
                }
              } else if (error === null || error === void 0 ? void 0 : error.networkError) {
                updateRefreshToken(refreshToken, cookieAttrs);
                _exit2 = true;
                return {};
              }

              _exit2 = true;
              return sessionExpired();
            });
          }
        }();
      }
    }();

    return Promise.resolve(_temp4 && _temp4.then ? _temp4.then(_temp3) : _temp3(_temp4));
  } catch (e) {
    return Promise.reject(e);
  }
};

function getOperationName(doc) {
  return doc.definitions.filter(function (definition) {
    return definition.kind === 'OperationDefinition' && definition.name;
  }) // @ts-ignore
  .map(function (x) {
    return x.name.value;
  })[0] || null;
}

function tokenExchange(cookieAttrs) {
  return function (_ref3) {
    var forward = _ref3.forward,
        client = _ref3.client;
    return function (ops$) {
      return pipe(ops$, mergeMap(function (operation) {
        var opName = getOperationName(operation.query);
        var isRefreshOp = opName === 'RefreshAccessToken';
        var token = getOrRefreshAccessToken(client, cookieAttrs);
        var fetchOptions = isRefreshOp ? Promise.resolve({}) : token.then(function (t) {
          return {
            headers: t ? {
              authorization: "Bearer " + t
            } : {}
          };
        });
        return pipe(fromPromise(fetchOptions), map(function (fetchOptions) {
          return _extends(_extends({}, operation), {}, {
            context: _extends(_extends({}, operation.context), {}, {
              fetchOptions: fetchOptions
            })
          });
        }));
      }), forward);
    };
  };
}

var defaultState = {
  refreshable: false
};
var TokenContext = /*#__PURE__*/createContext(defaultState);

function getTokenExpiry(accessToken) {
  if (!accessToken) {
    // https://stackoverflow.com/questions/3468607/why-does-settimeout-break-for-large-millisecond-delay-values
    return 0x7FFFFFFF;
  }

  var decoded = jwtDecode(accessToken); // refresh the token 90 seconds before it expires

  var WAIT_THRESHOLD = 90 * 1000;
  return decoded ? decoded.exp * 1000 - new Date().getTime() - WAIT_THRESHOLD : 3600 * 1000;
}

var TokenContextProvider = function TokenContextProvider(_ref) {
  var children = _ref.children,
      cookieAttrs = _ref.cookieAttrs;

  var _useState = useState(getAccessToken()),
      accessToken = _useState[0],
      setAccessToken = _useState[1];

  var client = useClient();
  var expiry = getTokenExpiry(accessToken);
  useTimeout(function () {
    refreshTokens(client, cookieAttrs).then(function (_ref2) {
      var accessToken = _ref2.accessToken;
      setAccessToken(accessToken);
    });
  }, expiry);
  useEventListener(Events.ACCESS_TOKEN_UPDATED_EVENT, function (_ref3) {
    var accessToken = _ref3.accessToken;
    setAccessToken(accessToken);
  });
  useEffect(function () {
    // @ts-ignore
    var subscriptionClient = window.subscriptionClient;

    if (!accessToken && (subscriptionClient === null || subscriptionClient === void 0 ? void 0 : subscriptionClient.client)) {
      subscriptionClient.close(true, true);
    }
  }, [accessToken]);

  if (!accessToken) {
    return React__default.createElement(TokenContext.Provider, {
      value: defaultState
    }, children);
  }

  return React__default.createElement(TokenContext.Provider, {
    value: {
      accessToken: accessToken,
      refreshable: true
    }
  }, children);
};

var useTokenContext = function useTokenContext() {
  return useContext(TokenContext);
};

var GET_PLAYER_INFO = {
  "kind": "Document",
  "definitions": [{
    "kind": "OperationDefinition",
    "operation": "query",
    "name": {
      "kind": "Name",
      "value": "GetPlayerInfo"
    },
    "variableDefinitions": [],
    "directives": [],
    "selectionSet": {
      "kind": "SelectionSet",
      "selections": [{
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "viewer"
        },
        "arguments": [],
        "directives": [],
        "selectionSet": {
          "kind": "SelectionSet",
          "selections": [{
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "id"
            },
            "arguments": [],
            "directives": []
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "player"
            },
            "arguments": [],
            "directives": [],
            "selectionSet": {
              "kind": "SelectionSet",
              "selections": [{
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "id"
                },
                "arguments": [],
                "directives": []
              }, {
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "accountStatus"
                },
                "arguments": [],
                "directives": [],
                "selectionSet": {
                  "kind": "SelectionSet",
                  "selections": [{
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "status"
                    },
                    "arguments": [],
                    "directives": []
                  }, {
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "cause"
                    },
                    "arguments": [],
                    "directives": []
                  }]
                }
              }, {
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "country"
                },
                "arguments": [],
                "directives": [],
                "selectionSet": {
                  "kind": "SelectionSet",
                  "selections": [{
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "code"
                    },
                    "arguments": [],
                    "directives": []
                  }, {
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "name"
                    },
                    "arguments": [],
                    "directives": []
                  }]
                }
              }, {
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "email"
                },
                "arguments": [],
                "directives": []
              }, {
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "personalInfo"
                },
                "arguments": [],
                "directives": [],
                "selectionSet": {
                  "kind": "SelectionSet",
                  "selections": [{
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "street"
                    },
                    "arguments": [],
                    "directives": []
                  }, {
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "city"
                    },
                    "arguments": [],
                    "directives": []
                  }, {
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "firstName"
                    },
                    "arguments": [],
                    "directives": []
                  }, {
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "lastName"
                    },
                    "arguments": [],
                    "directives": []
                  }, {
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "dateOfBirth"
                    },
                    "arguments": [],
                    "directives": []
                  }, {
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "zipCode"
                    },
                    "arguments": [],
                    "directives": []
                  }, {
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "ssn"
                    },
                    "arguments": [],
                    "directives": []
                  }]
                }
              }, {
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "emailVerified"
                },
                "arguments": [],
                "directives": []
              }, {
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "identityVerificationLimitDeadline"
                },
                "arguments": [],
                "directives": []
              }, {
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "isSmsMarketingAccepted"
                },
                "arguments": [],
                "directives": []
              }, {
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "isEmailMarketingAccepted"
                },
                "arguments": [],
                "directives": []
              }, {
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "termsAccepted"
                },
                "arguments": [],
                "directives": []
              }, {
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "selfExclusionDetails"
                },
                "arguments": [],
                "directives": [],
                "selectionSet": {
                  "kind": "SelectionSet",
                  "selections": [{
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "exclusionEndsAt"
                    },
                    "arguments": [],
                    "directives": []
                  }]
                }
              }, {
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "timeouts"
                },
                "arguments": [],
                "directives": [],
                "selectionSet": {
                  "kind": "SelectionSet",
                  "selections": [{
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "timeoutEndsAt"
                    },
                    "arguments": [],
                    "directives": []
                  }]
                }
              }]
            }
          }]
        }
      }]
    }
  }],
  "loc": {
    "start": 0,
    "end": 332,
    "source": {
      "body": "query GetPlayerInfo{viewer{id player{id accountStatus{status cause}country{code name}email personalInfo{street city firstName lastName dateOfBirth zipCode ssn}emailVerified identityVerificationLimitDeadline isSmsMarketingAccepted isEmailMarketingAccepted termsAccepted selfExclusionDetails{exclusionEndsAt}timeouts{timeoutEndsAt}}}}",
      "name": "GraphQL request",
      "locationOffset": {
        "line": 1,
        "column": 1
      }
    }
  }
};
var UPDATE_REQUIRED = {
  "kind": "Document",
  "definitions": [{
    "kind": "OperationDefinition",
    "operation": "subscription",
    "name": {
      "kind": "Name",
      "value": "PlayerUpdated"
    },
    "variableDefinitions": [],
    "directives": [],
    "selectionSet": {
      "kind": "SelectionSet",
      "selections": [{
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "playerUpdated"
        },
        "arguments": [],
        "directives": [],
        "selectionSet": {
          "kind": "SelectionSet",
          "selections": [{
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "isAccountClosed"
            },
            "arguments": [],
            "directives": []
          }]
        }
      }]
    }
  }],
  "loc": {
    "start": 0,
    "end": 58,
    "source": {
      "body": "subscription PlayerUpdated{playerUpdated{isAccountClosed}}",
      "name": "GraphQL request",
      "locationOffset": {
        "line": 1,
        "column": 1
      }
    }
  }
};
var AuthStatus;

(function (AuthStatus) {
  AuthStatus[AuthStatus["LOADING"] = 0] = "LOADING";
  AuthStatus[AuthStatus["LOGGED_IN"] = 1] = "LOGGED_IN";
  AuthStatus[AuthStatus["LOGGED_OUT"] = 2] = "LOGGED_OUT";
  AuthStatus[AuthStatus["ERROR"] = 3] = "ERROR";
})(AuthStatus || (AuthStatus = {}));

var defaultState$1 = {
  status: AuthStatus.LOADING
};
var PlayerContext = /*#__PURE__*/createContext(defaultState$1);

var PlayerContextProvider = function PlayerContextProvider(_ref) {
  var _data$viewer;

  var children = _ref.children;

  var _useTokenContext = useTokenContext(),
      refreshable = _useTokenContext.refreshable;

  var _useDinoQuery = useDinoQuery(GET_PLAYER_INFO, {
    skip: !refreshable
  }),
      data = _useDinoQuery.data,
      loading = _useDinoQuery.loading,
      refetch = _useDinoQuery.refetch;

  var player = data === null || data === void 0 ? void 0 : (_data$viewer = data.viewer) === null || _data$viewer === void 0 ? void 0 : _data$viewer.player;
  useSubscription({
    query: UPDATE_REQUIRED,
    pause: !refreshable
  }, function (_prev, data) {
    refetch({
      requestPolicy: 'network-only'
    });
    return data;
  });
  var status = AuthStatus.LOADING;

  if (!refreshable) {
    status = AuthStatus.LOGGED_OUT;
  } else if (player) {
    status = AuthStatus.LOGGED_IN;
  } else if (!loading) {
    status = AuthStatus.LOGGED_OUT;
  }

  return React__default.createElement(PlayerContext.Provider, {
    value: {
      status: status,
      player: player
    }
  }, children);
};

var usePlayerContext = function usePlayerContext() {
  return useContext(PlayerContext);
};

var LayoutContext = /*#__PURE__*/createContext({
  layout: {},
  isMobile: isMobile,
  submitLayout: function submitLayout() {}
});

var useLayout = function useLayout() {
  var ctx = useContext(LayoutContext);

  if (!ctx) {
    console.error('useLayout was used outside of LayoutContext.Provider');
  }

  return ctx;
};

var LayoutProvider = function LayoutProvider(_ref) {
  var layout = _ref.layout,
      children = _ref.children;

  var _useState = useState(layout),
      state = _useState[0],
      setState = _useState[1];

  var location = useLocation();
  useEffect(function () {
    if (layout !== state) {
      setState(layout);
    }
  }, [location]);
  var ctx = {
    layout: state,
    isMobile: isMobile,
    submitLayout: function submitLayout(props) {
      setState(Object.assign({}, state, props));
    }
  };
  return React__default.createElement(LayoutContext.Provider, {
    value: ctx
  }, children);
};

var DialogContext = /*#__PURE__*/createContext({
  dialog: null,
  close: function close() {},
  isOpen: false,
  showMessage: function showMessage(_title, _content) {}
});

var useDialogContext = function useDialogContext() {
  var ctx = useContext(DialogContext);

  if (!ctx) {
    console.error('useDialog was used outside of DialogContext.Provider');
  }

  return ctx;
};

var DialogProvider = function DialogProvider(_ref) {
  var children = _ref.children;

  var _React$useState = React__default.useState(null),
      dialog = _React$useState[0],
      setDialog = _React$useState[1];

  var ctx = useMemo(function () {
    return {
      close: function close() {
        return setDialog(null);
      },
      dialog: dialog,
      isOpen: !!dialog,
      showMessage: function showMessage(title, content) {
        setDialog({
          title: title,
          content: content,
          prompt: true
        });
      }
    };
  }, [dialog]);
  return React__default.createElement(DialogContext.Provider, {
    value: ctx
  }, children);
};

var LocaleContext = /*#__PURE__*/createContext('en');

var useLocale = function useLocale() {
  return useContext(LocaleContext);
};

var SESSION_SUBSCRIPTION = {
  "kind": "Document",
  "definitions": [{
    "kind": "OperationDefinition",
    "operation": "subscription",
    "name": {
      "kind": "Name",
      "value": "SessionDestroyed"
    },
    "variableDefinitions": [],
    "directives": [],
    "selectionSet": {
      "kind": "SelectionSet",
      "selections": [{
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "sessionDestroyed"
        },
        "arguments": [],
        "directives": [],
        "selectionSet": {
          "kind": "SelectionSet",
          "selections": [{
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "sessionId"
            },
            "arguments": [],
            "directives": []
          }]
        }
      }]
    }
  }],
  "loc": {
    "start": 0,
    "end": 58,
    "source": {
      "body": "subscription SessionDestroyed{sessionDestroyed{sessionId}}",
      "name": "GraphQL request",
      "locationOffset": {
        "line": 1,
        "column": 1
      }
    }
  }
};

var LogoutDialog = function LogoutDialog(_ref) {
  var reason = _ref.reason;

  var _useConfigContext = useConfigContext(),
      getTranslation = _useConfigContext.getTranslation;

  return React__default.createElement(React__default.Fragment, null, getTranslation(reason));
};

var SessionLifecycle = function SessionLifecycle(_ref2) {
  var children = _ref2.children,
      cookieAttrs = _ref2.cookieAttrs;

  var _useTokenContext = useTokenContext(),
      refreshable = _useTokenContext.refreshable;

  var _useDialogContext = useDialogContext(),
      showMessage = _useDialogContext.showMessage;

  var _useLogout = useLogout(LogoutReason.LOGGED_IN_FROM_ANOTHER_DEVICE),
      logout = _useLogout.logout;

  useSubscription({
    query: SESSION_SUBSCRIPTION,
    pause: !refreshable
  }, function (_prev, data) {
    // TODO: Check the session id to see that it's the correct session
    // that we destroy.
    if (data && data.sessionDestroyed.sessionId) {
      logout();
    }

    return data;
  });
  useEventListener(Events.SESSION_DESTROYED, function () {
    logout();
  });
  useEventListener(Events.LOGOUT, function (_ref3) {
    var reason = _ref3.reason,
        exitPath = _ref3.exitPath;
    removeAccessTokens(cookieAttrs);

    if (reason === LogoutReason.LOGGED_IN_FROM_ANOTHER_DEVICE || reason === LogoutReason.SESSION_EXPIRED) {
      showMessage(undefined, React__default.createElement(LogoutDialog, {
        reason: reason
      }));
    }

    if (exitPath) {
      navigate(exitPath);
    }
  });
  return React__default.createElement(React__default.Fragment, null, children);
};

var GET_WALLET = {
  "kind": "Document",
  "definitions": [{
    "kind": "OperationDefinition",
    "operation": "query",
    "name": {
      "kind": "Name",
      "value": "GetWallet"
    },
    "variableDefinitions": [],
    "directives": [],
    "selectionSet": {
      "kind": "SelectionSet",
      "selections": [{
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "viewer"
        },
        "arguments": [],
        "directives": [],
        "selectionSet": {
          "kind": "SelectionSet",
          "selections": [{
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "id"
            },
            "arguments": [],
            "directives": []
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "wallet"
            },
            "arguments": [],
            "directives": [],
            "selectionSet": {
              "kind": "SelectionSet",
              "selections": [{
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "id"
                },
                "arguments": [],
                "directives": []
              }, {
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "balance"
                },
                "arguments": [],
                "directives": []
              }, {
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "currency"
                },
                "arguments": [],
                "directives": []
              }]
            }
          }]
        }
      }]
    }
  }],
  "loc": {
    "start": 0,
    "end": 55,
    "source": {
      "body": "query GetWallet{viewer{id wallet{id balance currency}}}",
      "name": "GraphQL request",
      "locationOffset": {
        "line": 1,
        "column": 1
      }
    }
  }
};
var WALLET_SUBSCRIPTION = {
  "kind": "Document",
  "definitions": [{
    "kind": "OperationDefinition",
    "operation": "subscription",
    "name": {
      "kind": "Name",
      "value": "WalletSubscription"
    },
    "variableDefinitions": [],
    "directives": [],
    "selectionSet": {
      "kind": "SelectionSet",
      "selections": [{
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "balanceUpdated"
        },
        "arguments": [],
        "directives": [],
        "selectionSet": {
          "kind": "SelectionSet",
          "selections": [{
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "balance"
            },
            "arguments": [],
            "directives": []
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "currency"
            },
            "arguments": [],
            "directives": []
          }]
        }
      }]
    }
  }],
  "loc": {
    "start": 0,
    "end": 65,
    "source": {
      "body": "subscription WalletSubscription{balanceUpdated{balance currency}}",
      "name": "GraphQL request",
      "locationOffset": {
        "line": 1,
        "column": 1
      }
    }
  }
};
var WalletStatus;

(function (WalletStatus) {
  WalletStatus[WalletStatus["LOADING"] = 0] = "LOADING";
  WalletStatus[WalletStatus["NOT_AVAILABLE"] = 1] = "NOT_AVAILABLE";
  WalletStatus[WalletStatus["STREAMING"] = 2] = "STREAMING";
})(WalletStatus || (WalletStatus = {}));

var initialState = {
  status: WalletStatus.LOADING
};
var WalletContext = /*#__PURE__*/createContext(initialState);

var WalletContextProvider = function WalletContextProvider(_ref) {
  var _res$data, _data$viewer;

  var children = _ref.children;

  var _useTokenContext = useTokenContext(),
      refreshable = _useTokenContext.refreshable;

  var _useDinoQuery = useDinoQuery(GET_WALLET, {
    skip: !refreshable
  }),
      data = _useDinoQuery.data;

  var _useSubscription = useSubscription({
    query: WALLET_SUBSCRIPTION,
    pause: !refreshable
  }),
      res = _useSubscription[0];

  var balance = ((_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.balanceUpdated) || (data === null || data === void 0 ? void 0 : (_data$viewer = data.viewer) === null || _data$viewer === void 0 ? void 0 : _data$viewer.wallet);
  var status = WalletStatus.LOADING;

  if (!refreshable) {
    status = WalletStatus.NOT_AVAILABLE;
  } else if (balance) {
    status = WalletStatus.STREAMING;
  }

  return React__default.createElement(WalletContext.Provider, {
    value: _extends({
      status: status
    }, balance || {})
  }, children);
};

var useWalletContext = function useWalletContext() {
  return useContext(WalletContext);
};

var ZendeskContext = /*#__PURE__*/createContext({
  toggleLiveChat: function toggleLiveChat() {},
  loading: false
});
var GENERATE_ZENDESK_TOKEN_MUTATION = {
  "kind": "Document",
  "definitions": [{
    "kind": "OperationDefinition",
    "operation": "mutation",
    "name": {
      "kind": "Name",
      "value": "GenerateZendeskToken"
    },
    "variableDefinitions": [],
    "directives": [],
    "selectionSet": {
      "kind": "SelectionSet",
      "selections": [{
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "generateZendeskToken"
        },
        "arguments": [],
        "directives": [],
        "selectionSet": {
          "kind": "SelectionSet",
          "selections": [{
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "token"
            },
            "arguments": [],
            "directives": []
          }]
        }
      }]
    }
  }],
  "loc": {
    "start": 0,
    "end": 58,
    "source": {
      "body": "mutation GenerateZendeskToken{generateZendeskToken{token}}",
      "name": "GraphQL request",
      "locationOffset": {
        "line": 1,
        "column": 1
      }
    }
  }
};

var useZendeskContext = function useZendeskContext() {
  var ctx = useContext(ZendeskContext);

  if (!ctx) {
    console.error('useZendeskContext was used outside of ZendeskContext.Provider');
  }

  return ctx;
};

function zenChatLanguage(locale) {
  switch (locale) {
    case 'de':
      return 'Deutsch';

    case 'fi':
      return 'Suomi';

    case 'no':
    case 'nb':
    case 'nn':
      return 'Norsk';

    default:
      return 'English';
  }
}

function setLocale(locale) {
  if (window.zE) {
    window.zE('webWidget', 'setLocale', locale.replace('_', '-'));
  }
}

function showWidget() {
  if (window.zE) {
    window.zE('webWidget', 'show');
    window.zE('webWidget', 'open');
  }
}

function configure(onLoaded) {
  if (typeof window.zE === 'undefined') {
    setTimeout(function () {
      return configure(onLoaded);
    }, 50);
    return;
  }

  window.zE('webWidget:on', 'chat:connected', function () {
    // If the user's language is set to Dutch then force the language of the chat widget to be English
    // This is recommended due to the strictness of the Dutch regulators that the site not be in Dutch
    if (navigator.language === 'nl') window.zE('webWidget', 'setLocale', 'en');
  }); // This will ensure that the widget button stays hidden if the player clicks the minimize button

  window.zE('webWidget', 'hide');
  window.zE('webWidget:on', 'close', function () {
    window.zE('webWidget', 'hide');
  });
  onLoaded();
}

var ZendeskProvider = function ZendeskProvider(_ref) {
  var locale = _ref.locale,
      zendeskKey = _ref.zendeskKey,
      children = _ref.children;

  var _mounted = React__default.useRef(false);

  var _useState = useState(false),
      isLoading = _useState[0],
      setIsLoading = _useState[1];

  var client = useClient();
  var chatState = {
    loading: isLoading,
    toggleLiveChat: function toggleLiveChat(onToggle) {
      setIsLoading(true);

      if (!_mounted.current) {
        try {
          window.zESettings = {
            webWidget: {
              color: {
                // TODO: Make these stylable using themes
                button: '#57bef4',
                header: '#f72626'
              },
              chat: {
                // Set the departments / languages and set the default for the user
                departments: {
                  // When you are ready to add more languages, then you will need to enable them here.
                  // For example, enabled: ['English', 'Deutsch', 'Suomi', 'Norsk']
                  enabled: ['English'],
                  select: zenChatLanguage(locale)
                },
                // Set a brand tag to help with routing the ticket
                // if you want to tag VIP then use: tags: ['mrgold','vip']
                tags: [process.env.GATSBY_REPOSITORY]
              },
              // Set the callback for user verification
              // https://support.zendesk.com/hc/en-us/articles/360022185314-Enabling-authenticated-visitors-in-the-Chat-widget
              authenticate: {
                chat: {
                  jwtFn: function jwtFn(callback) {
                    client.mutation(GENERATE_ZENDESK_TOKEN_MUTATION).toPromise().then(function (response) {
                      var _response$data;

                      callback(response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.generateZendeskToken.token);
                    });
                  }
                }
              }
            }
          };
          var script = document.createElement('script');
          script.id = 'ze-snippet';
          script.setAttribute('src', "https://static.zdassets.com/ekr/snippet.js?key=" + zendeskKey);
          document.head.appendChild(script);
          _mounted.current = true;
          configure(function () {
            setLocale(locale);
            setIsLoading(false);
            showWidget();
            onToggle();
          });
        } catch (e) {
          Promise.reject(e);
        }
      } else {
        showWidget();
        onToggle();
        _mounted.current = true;
      }
    }
  };
  return React__default.createElement(ZendeskContext.Provider, {
    value: chatState
  }, children);
};

var SUBMIT_ACCEPTED_TERMS = {
  "kind": "Document",
  "definitions": [{
    "kind": "OperationDefinition",
    "operation": "mutation",
    "name": {
      "kind": "Name",
      "value": "SubmitAcceptTerms"
    },
    "variableDefinitions": [],
    "directives": [],
    "selectionSet": {
      "kind": "SelectionSet",
      "selections": [{
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "acceptTerms"
        },
        "arguments": [],
        "directives": [],
        "selectionSet": {
          "kind": "SelectionSet",
          "selections": [{
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "id"
            },
            "arguments": [],
            "directives": []
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "termsAccepted"
            },
            "arguments": [],
            "directives": []
          }]
        }
      }]
    }
  }],
  "loc": {
    "start": 0,
    "end": 57,
    "source": {
      "body": "mutation SubmitAcceptTerms{acceptTerms{id termsAccepted}}",
      "name": "GraphQL request",
      "locationOffset": {
        "line": 1,
        "column": 1
      }
    }
  }
};

function useAcceptTerms(_ref) {
  var onError = _ref.onError;

  var _useDinoMutation = useDinoMutation(SUBMIT_ACCEPTED_TERMS, {
    onCompleted: function onCompleted() {
      trigger(termsAcceptedEvent);
      typeof window !== 'undefined' ? window.scrollTo(0, 0) : null;
    },
    onError: handleError(onError)
  }),
      acceptTerms = _useDinoMutation[0],
      loading = _useDinoMutation[1].loading;

  return {
    acceptTerms: acceptTerms,
    submitting: loading
  };
}

var NotificationTypes;

(function (NotificationTypes) {
  NotificationTypes["TIMEOUT"] = "TIMEOUT";
  NotificationTypes["SELF_EXCLUDED"] = "SELF_EXCLUDED";
  NotificationTypes["ACCOUNT_CLOSED"] = "ACCOUNT_CLOSED";
  NotificationTypes["EMAIL_NOT_VERIFIED"] = "EMAIL_NOT_VERIFIED";
  NotificationTypes["KYC_REQUIRED"] = "KYC_REQUIRED";
  NotificationTypes["SESSION_LIMIT_REACHED"] = "SESSION_LIMIT_REACHED";
  NotificationTypes["SELF_EXCLUDED_INDEFINITE"] = "SELF_EXCLUDED_INDEFINITE";
})(NotificationTypes || (NotificationTypes = {}));

var useAccountNotifications = function useAccountNotifications() {
  var _usePlayerContext = usePlayerContext(),
      status = _usePlayerContext.status,
      player = _usePlayerContext.player; // const { sessionLimit } = useSessionTimeLimit();
  //TODO: enable once we send email with verification link
  // const [hideEmail, setHideEmail] = useState(false);


  var _useState = useState(false),
      hideKyc = _useState[0],
      setHideKyc = _useState[1];

  if (status !== AuthStatus.LOGGED_IN || !player) {
    return {
      notifications: []
    };
  }

  var notifications = [];

  if (player.timeouts) {
    notifications.push({
      type: NotificationTypes.TIMEOUT,
      until: player.timeouts.timeoutEndsAt
    });
  }

  if (player.selfExclusionDetails) {
    if (player.selfExclusionDetails.exclusionEndsAt) {
      notifications.push({
        type: NotificationTypes.SELF_EXCLUDED,
        until: player.selfExclusionDetails.exclusionEndsAt
      });
    } else {
      notifications.push({
        type: NotificationTypes.SELF_EXCLUDED_INDEFINITE
      });
    }
  }

  if (player.accountStatus.status === 'Closed') {
    notifications.push({
      type: NotificationTypes.ACCOUNT_CLOSED
    });
  } // TODO: Re-enable
  // const dayLimit = wallet?.sessionLimit?.dayLimit;
  // const monthLimit = wallet?.sessionLimit?.monthLimit;
  // const weekLimit = wallet?.sessionLimit?.weekLimit;
  // if (monthLimit && monthLimit.available <= 0) {
  //   notifications.push({
  //     type: NotificationTypes.SESSION_LIMIT_REACHED,
  //     until: monthLimit.currentPeriodEndTime,
  //   });
  // } else if (weekLimit && weekLimit.available <= 0) {
  //   notifications.push({
  //     type: NotificationTypes.SESSION_LIMIT_REACHED,
  //     until: weekLimit.currentPeriodEndTime,
  //   });
  // } else if (dayLimit && dayLimit.available <= 0) {
  //   notifications.push({
  //     type: NotificationTypes.SESSION_LIMIT_REACHED,
  //     until: dayLimit.currentPeriodEndTime,
  //   });
  // }
  //TODO: enable once we send email with verification link
  // if (!hideEmail && !player.emailVerified) {
  //   notifications.push({
  //     type: NotificationTypes.EMAIL_NOT_VERIFIED,
  //     hide: () => setHideEmail(true),
  //     callback: (path: any) => {
  //       setHideEmail(true);
  //       navigate(path);
  //     },
  //     callbackButton: 'NOTIFICATION_EMAIL_NOT_VERIFIED',
  //   });
  // }


  if (!hideKyc && player.identityVerificationLimitDeadline) {
    notifications.push({
      type: NotificationTypes.KYC_REQUIRED,
      deadline: player.identityVerificationLimitDeadline,
      hide: function hide() {
        return setHideKyc(true);
      },
      callback: function callback(path) {
        setHideKyc(true);
        navigate$1(path);
      },
      callbackButton: 'NOTIFICATION_KYC_REQUIRED'
    });
  }

  return {
    notifications: notifications
  };
};

function useRequiresAdditionalInfo() {
  var _player$country;

  var _useTokenContext = useTokenContext(),
      refreshable = _useTokenContext.refreshable;

  var _usePlayerContext = usePlayerContext(),
      status = _usePlayerContext.status,
      player = _usePlayerContext.player;

  if (!refreshable) {
    return {
      requiresAdditionalInfo: false
    };
  }

  var loading = status === AuthStatus.LOADING;
  return {
    loading: loading,
    requiresAdditionalInfo: !loading && ((player === null || player === void 0 ? void 0 : (_player$country = player.country) === null || _player$country === void 0 ? void 0 : _player$country.code) || '').trim().length <= 0
  };
}

function useCheckTerms(_ref) {
  var termsUpdatedAt = _ref.termsUpdatedAt;

  var _useTokenContext = useTokenContext(),
      refreshable = _useTokenContext.refreshable;

  var _usePlayerContext = usePlayerContext(),
      player = _usePlayerContext.player,
      status = _usePlayerContext.status;

  if (!refreshable) {
    return {
      termsAccepted: true,
      loading: false
    };
  }

  var termsAccepted = player === null || player === void 0 ? void 0 : player.termsAccepted;
  var acceptedAfter = termsUpdatedAt && termsAccepted && new Date(termsAccepted) > termsUpdatedAt;
  return {
    termsAccepted: termsAccepted && acceptedAfter,
    loading: status === AuthStatus.LOADING,
    firstTimeTerms: !!termsAccepted
  };
}

function useFetchJson(url) {
  var fetchUrl = function fetchUrl() {
    try {
      return Promise.resolve(fetch(url)).then(function (response) {
        return Promise.resolve(response.json()).then(function (json) {
          setData(json);
          setLoading(false);
        });
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  var _useState = useState(null),
      data = _useState[0],
      setData = _useState[1];

  var _useState2 = useState(true),
      loading = _useState2[0],
      setLoading = _useState2[1];

  useEffect(function () {
    fetchUrl();
  }, [url]);
  return [data, loading];
}

var useIsAuthenticated = function useIsAuthenticated() {
  var _usePlayerContext = usePlayerContext(),
      status = _usePlayerContext.status;

  if (typeof window === 'undefined') {
    return {
      isLoggedIn: false,
      isLoading: true,
      error: false
    };
  }

  return {
    isLoggedIn: status === AuthStatus.LOGGED_IN,
    isLoading: status === AuthStatus.LOADING,
    error: status === AuthStatus.ERROR
  };
};

var GET_SESSION_WAGER_ACTIVITY = {
  "kind": "Document",
  "definitions": [{
    "kind": "OperationDefinition",
    "operation": "query",
    "name": {
      "kind": "Name",
      "value": "GetSessionWagerActivity"
    },
    "variableDefinitions": [],
    "directives": [],
    "selectionSet": {
      "kind": "SelectionSet",
      "selections": [{
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "viewer"
        },
        "arguments": [],
        "directives": [],
        "selectionSet": {
          "kind": "SelectionSet",
          "selections": [{
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "id"
            },
            "arguments": [],
            "directives": []
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "player"
            },
            "arguments": [],
            "directives": [],
            "selectionSet": {
              "kind": "SelectionSet",
              "selections": [{
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "id"
                },
                "arguments": [],
                "directives": []
              }, {
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "sessionWagerActivity"
                },
                "arguments": [],
                "directives": [],
                "selectionSet": {
                  "kind": "SelectionSet",
                  "selections": [{
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "currency"
                    },
                    "arguments": [],
                    "directives": []
                  }, {
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "totalBets"
                    },
                    "arguments": [],
                    "directives": []
                  }, {
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "totalWins"
                    },
                    "arguments": [],
                    "directives": []
                  }]
                }
              }]
            }
          }]
        }
      }]
    }
  }],
  "loc": {
    "start": 0,
    "end": 103,
    "source": {
      "body": "query GetSessionWagerActivity{viewer{id player{id sessionWagerActivity{currency totalBets totalWins}}}}",
      "name": "GraphQL request",
      "locationOffset": {
        "line": 1,
        "column": 1
      }
    }
  }
};

var useSessionWagerActivity = function useSessionWagerActivity() {
  var _data$viewer, _data$viewer$player;

  var _useIsAuthenticated = useIsAuthenticated(),
      authLoading = _useIsAuthenticated.isLoading,
      isLoggedIn = _useIsAuthenticated.isLoggedIn;

  var _useDinoQuery = useDinoQuery(GET_SESSION_WAGER_ACTIVITY, {
    skip: !isLoggedIn,
    onError: handleError(),
    requestPolicy: 'network-only'
  }),
      loading = _useDinoQuery.loading,
      data = _useDinoQuery.data,
      refetch = _useDinoQuery.refetch;

  var sessionWagerActivity = data === null || data === void 0 ? void 0 : (_data$viewer = data.viewer) === null || _data$viewer === void 0 ? void 0 : (_data$viewer$player = _data$viewer.player) === null || _data$viewer$player === void 0 ? void 0 : _data$viewer$player.sessionWagerActivity;
  var result = {
    sessionWagerActivity: sessionWagerActivity,
    loading: loading || authLoading,
    refetch: refetch
  };
  return result;
};

var GET_LAST_PLAYED_GAMES = {
  "kind": "Document",
  "definitions": [{
    "kind": "OperationDefinition",
    "operation": "query",
    "name": {
      "kind": "Name",
      "value": "GetLastPlayedGames"
    },
    "variableDefinitions": [],
    "directives": [],
    "selectionSet": {
      "kind": "SelectionSet",
      "selections": [{
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "viewer"
        },
        "arguments": [],
        "directives": [],
        "selectionSet": {
          "kind": "SelectionSet",
          "selections": [{
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "id"
            },
            "arguments": [],
            "directives": []
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "recentlyPlayedGamesV2"
            },
            "arguments": [{
              "kind": "Argument",
              "name": {
                "kind": "Name",
                "value": "maxResults"
              },
              "value": {
                "kind": "IntValue",
                "value": "5"
              }
            }],
            "directives": [],
            "selectionSet": {
              "kind": "SelectionSet",
              "selections": [{
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "gameId"
                },
                "arguments": [],
                "directives": []
              }, {
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "gameProvider"
                },
                "arguments": [],
                "directives": []
              }, {
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "gameDescriptor"
                },
                "arguments": [],
                "directives": [],
                "selectionSet": {
                  "kind": "SelectionSet",
                  "selections": [{
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "json"
                    },
                    "arguments": [],
                    "directives": []
                  }]
                }
              }]
            }
          }]
        }
      }]
    }
  }],
  "loc": {
    "start": 0,
    "end": 114,
    "source": {
      "body": "query GetLastPlayedGames{viewer{id recentlyPlayedGamesV2(maxResults:5){gameId gameProvider gameDescriptor{json}}}}",
      "name": "GraphQL request",
      "locationOffset": {
        "line": 1,
        "column": 1
      }
    }
  }
};

var useLastPlayedGames = function useLastPlayedGames() {
  var _data$viewer, _data$viewer$recently;

  var _useIsAuthenticated = useIsAuthenticated(),
      authLoading = _useIsAuthenticated.isLoading,
      isLoggedIn = _useIsAuthenticated.isLoggedIn;

  var _useDinoQuery = useDinoQuery(GET_LAST_PLAYED_GAMES, {
    skip: !isLoggedIn,
    onError: handleError()
  }),
      loading = _useDinoQuery.loading,
      data = _useDinoQuery.data,
      refetch = _useDinoQuery.refetch;

  useEventListener(Events.GAME_CLOSED, function () {
    return isLoggedIn && refetch({
      requestPolicy: 'network-only'
    });
  });
  var games = data === null || data === void 0 ? void 0 : (_data$viewer = data.viewer) === null || _data$viewer === void 0 ? void 0 : (_data$viewer$recently = _data$viewer.recentlyPlayedGamesV2) === null || _data$viewer$recently === void 0 ? void 0 : _data$viewer$recently.filter(function (game) {
    return game.gameDescriptor;
  });
  var result = {
    lastPlayedGames: isLoggedIn ? games === null || games === void 0 ? void 0 : games.map(function (game) {
      var _game$gameDescriptor;

      return game === null || game === void 0 ? void 0 : (_game$gameDescriptor = game.gameDescriptor) === null || _game$gameDescriptor === void 0 ? void 0 : _game$gameDescriptor.json;
    }) : [],
    loading: loading || authLoading
  };
  return result;
};

var cachedScripts = [];

var removeJsFile = function removeJsFile(filename) {
  var scripts = Array.from(document.getElementsByTagName('script'));
  scripts.forEach(function (el) {
    if (el && el.getAttribute('src') !== null && el.getAttribute('src') === filename) {
      if (el.parentNode) el.parentNode.removeChild(el);
    }
  });
};

var useScript = function useScript(src, options) {
  var _useState = useState({
    loaded: false,
    error: false
  }),
      state = _useState[0],
      setState = _useState[1];

  useEffect(function () {
    if (cachedScripts.includes(src)) {
      setState({
        loaded: true,
        error: false
      });
      return function () {};
    } else {
      if (!options || !options.reload) {
        cachedScripts.push(src);
      } // Remove script if option reload is true


      if (options && options.reload) {
        removeJsFile(src);
      } // Create script


      var script = document.createElement('script');
      script.src = src;
      script.async = true; // Script event listener callbacks for load and error

      var onScriptLoad = function onScriptLoad() {
        setState({
          loaded: true,
          error: false
        });
      };

      var onScriptError = function onScriptError() {
        // Remove from cachedScripts we can try loading again
        var index = cachedScripts.indexOf(src);
        if (index >= 0) cachedScripts.splice(index, 1);
        script.remove();
        setState({
          loaded: true,
          error: true
        });
      };

      script.addEventListener('load', onScriptLoad);
      script.addEventListener('error', onScriptError); // Add script to document body

      if (typeof window !== 'undefined') {
        window.document.body.appendChild(script);
      } // Remove event listeners on cleanup


      return function () {
        script.removeEventListener('load', onScriptLoad);
        script.removeEventListener('error', onScriptError);
      };
    }
  }, [src]);
  return [state.loaded, state.error];
};

function useSessionInfo() {
  var _useIsAuthenticated = useIsAuthenticated(),
      isLoggedIn = _useIsAuthenticated.isLoggedIn,
      isLoading = _useIsAuthenticated.isLoading;

  var sessionInfo = useMemo(function () {
    var accessToken = getAccessToken();

    if (accessToken) {
      var _jwtDecode = jwtDecode(accessToken),
          playerId = _jwtDecode.playerId,
          sessionId = _jwtDecode.sessionId;

      return {
        playerId: playerId,
        sessionId: sessionId
      };
    } else {
      return {
        sessionId: null,
        playerId: null
      };
    }
  }, [isLoggedIn]);
  return _extends(_extends({}, sessionInfo), {}, {
    isLoading: isLoading
  });
}

var useTimer = function useTimer(startFrom, options) {
  var _useState = useState(startFrom),
      time = _useState[0],
      setTime = _useState[1];

  useEffect(function () {
    var timer = setTimeout(function () {
      setTime(time - 1);
    }, 1000);

    if (time === 0) {
      clearTimeout(timer);

      if (options && options.onCompleted) {
        return options.onCompleted();
      }
    }
  }, [time]);
  return time;
};

var useWindowSize = function useWindowSize() {
  var isBrowser = typeof window === 'object';

  var _useState = useState(isBrowser ? [window.innerWidth, window.innerHeight] : [0, 0]),
      size = _useState[0],
      setSize = _useState[1];

  useLayoutEffect(function () {
    function updateSize() {
      if (isBrowser) {
        setSize([window.innerWidth, window.innerHeight]);
      }
    }

    window.addEventListener('resize', updateSize);
    updateSize();
    return function () {
      return window.removeEventListener('resize', updateSize);
    };
  }, []);
  return {
    width: size[0],
    height: size[1]
  };
};

var VERIFY_EMAIL = {
  "kind": "Document",
  "definitions": [{
    "kind": "OperationDefinition",
    "operation": "mutation",
    "name": {
      "kind": "Name",
      "value": "VerifyEmail"
    },
    "variableDefinitions": [{
      "kind": "VariableDefinition",
      "variable": {
        "kind": "Variable",
        "name": {
          "kind": "Name",
          "value": "emailVerificationToken"
        }
      },
      "type": {
        "kind": "NonNullType",
        "type": {
          "kind": "NamedType",
          "name": {
            "kind": "Name",
            "value": "String"
          }
        }
      },
      "directives": []
    }],
    "directives": [],
    "selectionSet": {
      "kind": "SelectionSet",
      "selections": [{
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "verifyEmail"
        },
        "arguments": [{
          "kind": "Argument",
          "name": {
            "kind": "Name",
            "value": "emailVerificationToken"
          },
          "value": {
            "kind": "Variable",
            "name": {
              "kind": "Name",
              "value": "emailVerificationToken"
            }
          }
        }],
        "directives": [],
        "selectionSet": {
          "kind": "SelectionSet",
          "selections": [{
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "id"
            },
            "arguments": [],
            "directives": []
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "emailVerified"
            },
            "arguments": [],
            "directives": []
          }]
        }
      }]
    }
  }],
  "loc": {
    "start": 0,
    "end": 132,
    "source": {
      "body": "mutation VerifyEmail($emailVerificationToken:String!){verifyEmail(emailVerificationToken:$emailVerificationToken){id emailVerified}}",
      "name": "GraphQL request",
      "locationOffset": {
        "line": 1,
        "column": 1
      }
    }
  }
};

function useVerifyEmail(_ref) {
  var onError = _ref.onError,
      _onCompleted = _ref.onCompleted;

  var _usePlayerContext = usePlayerContext(),
      status = _usePlayerContext.status,
      player = _usePlayerContext.player;

  var _useState = useState(false),
      submitting = _useState[0],
      setSubmitting = _useState[1];

  var _useDinoMutation = useDinoMutation(VERIFY_EMAIL, {
    onCompleted: function onCompleted(data) {
      trigger(emailVerifiedEvent);
      _onCompleted && _onCompleted(data.verifyEmail ? data.verifyEmail : false);
    },
    onError: handleError(onError, [ErrorType.InvalidOrExpiredTokenFailure])
  }),
      verifyEmail = _useDinoMutation[0];

  return {
    loading: status === AuthStatus.LOADING,
    submitting: submitting,
    emailVerified: player === null || player === void 0 ? void 0 : player.emailVerified,
    verifyUserEmail: function verifyUserEmail(variables) {
      setSubmitting(true);
      verifyEmail(variables)["finally"](function () {
        setSubmitting(false);
      });
    }
  };
} // A type of promise-like that resolves synchronously and supports only one observer


var _iteratorSymbol = /*#__PURE__*/typeof Symbol !== "undefined" ? Symbol.iterator || (Symbol.iterator = /*#__PURE__*/Symbol("Symbol.iterator")) : "@@iterator"; // Asynchronously iterate through an object's values


var _asyncIteratorSymbol = /*#__PURE__*/typeof Symbol !== "undefined" ? Symbol.asyncIterator || (Symbol.asyncIterator = /*#__PURE__*/Symbol("Symbol.asyncIterator")) : "@@asyncIterator"; // Asynchronously iterate on a value using it's async iterator if present, or its synchronous iterator if missing


function _catch(body, recover) {
  try {
    var result = body();
  } catch (e) {
    return recover(e);
  }

  if (result && result.then) {
    return result.then(void 0, recover);
  }

  return result;
} // Asynchronously await a promise and pass the result to a finally continuation


function _finallyRethrows(body, finalizer) {
  try {
    var result = body();
  } catch (e) {
    return finalizer(true, e);
  }

  if (result && result.then) {
    return result.then(finalizer.bind(null, false), finalizer.bind(null, true));
  }

  return finalizer(false, result);
} // Asynchronously await a promise and invoke a finally continuation that always overrides the result


var GenerateDocumentUrlMutation = {
  "kind": "Document",
  "definitions": [{
    "kind": "OperationDefinition",
    "operation": "mutation",
    "name": {
      "kind": "Name",
      "value": "GenerateDocumentUrl"
    },
    "variableDefinitions": [],
    "directives": [],
    "selectionSet": {
      "kind": "SelectionSet",
      "selections": [{
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "generateDocumentUrl"
        },
        "arguments": [],
        "directives": [],
        "selectionSet": {
          "kind": "SelectionSet",
          "selections": [{
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "url"
            },
            "arguments": [],
            "directives": []
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "documentId"
            },
            "arguments": [],
            "directives": []
          }]
        }
      }]
    }
  }],
  "loc": {
    "start": 0,
    "end": 65,
    "source": {
      "body": "mutation GenerateDocumentUrl{generateDocumentUrl{url documentId}}",
      "name": "GraphQL request",
      "locationOffset": {
        "line": 1,
        "column": 1
      }
    }
  }
};
var UploadDocumentMutation = {
  "kind": "Document",
  "definitions": [{
    "kind": "OperationDefinition",
    "operation": "mutation",
    "name": {
      "kind": "Name",
      "value": "UploadDocument"
    },
    "variableDefinitions": [{
      "kind": "VariableDefinition",
      "variable": {
        "kind": "Variable",
        "name": {
          "kind": "Name",
          "value": "documentId"
        }
      },
      "type": {
        "kind": "NonNullType",
        "type": {
          "kind": "NamedType",
          "name": {
            "kind": "Name",
            "value": "ID"
          }
        }
      },
      "directives": []
    }],
    "directives": [],
    "selectionSet": {
      "kind": "SelectionSet",
      "selections": [{
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "uploadDocument"
        },
        "arguments": [{
          "kind": "Argument",
          "name": {
            "kind": "Name",
            "value": "documentId"
          },
          "value": {
            "kind": "Variable",
            "name": {
              "kind": "Name",
              "value": "documentId"
            }
          }
        }],
        "directives": [],
        "selectionSet": {
          "kind": "SelectionSet",
          "selections": [{
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "id"
            },
            "arguments": [],
            "directives": []
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "status"
            },
            "arguments": [],
            "directives": []
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "verifiedAt"
            },
            "arguments": [],
            "directives": []
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "uploadedAt"
            },
            "arguments": [],
            "directives": []
          }]
        }
      }]
    }
  }],
  "loc": {
    "start": 0,
    "end": 113,
    "source": {
      "body": "mutation UploadDocument($documentId:ID!){uploadDocument(documentId:$documentId){id status verifiedAt uploadedAt}}",
      "name": "GraphQL request",
      "locationOffset": {
        "line": 1,
        "column": 1
      }
    }
  }
};

function useDocumentUpload(props) {
  var documentUploadMessage = props.documentUploadMessage,
      documentUploadSuccesMessage = props.documentUploadSuccesMessage,
      documentUploadErrorMessage = props.documentUploadErrorMessage;
  var UPLOAD_MESSAGE = documentUploadMessage || 'Drag &#38; drop your file here, or click to upload';
  var UPLOAD_SUCCESS_MESSAGE = documentUploadSuccesMessage || 'Document has been uploaded successfully';
  var UPLOAD_ERROR_MESSAGE = documentUploadErrorMessage || 'Error uploading the document, please try again or contact our support team';
  var INITIAL_MESSAGE = {
    text: UPLOAD_MESSAGE,
    code: 0
  };
  var SUCCESS_MESSAGE = {
    text: UPLOAD_SUCCESS_MESSAGE,
    code: 1
  };
  var ERROR_MESSAGE = {
    text: UPLOAD_ERROR_MESSAGE,
    code: 2
  };

  var _useState = useState(false),
      loading = _useState[0],
      setLoading = _useState[1];

  var _useState2 = useState(INITIAL_MESSAGE),
      message = _useState2[0],
      setMessage = _useState2[1];

  var _useDinoMutation = useDinoMutation(GenerateDocumentUrlMutation, {
    onError: function onError() {
      setMessage(ERROR_MESSAGE);
    },
    onCompleted: function onCompleted() {
      setMessage(SUCCESS_MESSAGE);
    }
  }),
      generateDocumentUrl = _useDinoMutation[0];

  var _useDinoMutation2 = useDinoMutation(UploadDocumentMutation, {
    onError: function onError() {
      setMessage(ERROR_MESSAGE);
    },
    onCompleted: function onCompleted() {
      setMessage(SUCCESS_MESSAGE);
    }
  }),
      uploadDocument = _useDinoMutation2[0];

  var onDrop = useCallback(function (accepted) {
    try {
      var _temp2 = _finallyRethrows(function () {
        return _catch(function () {
          setLoading(true);
          return Promise.resolve(generateDocumentUrl()).then(function (respond) {
            var _respond$data, _respond$data$generat, _respond$data2, _respond$data2$genera;

            var signedUrl = respond === null || respond === void 0 ? void 0 : (_respond$data = respond.data) === null || _respond$data === void 0 ? void 0 : (_respond$data$generat = _respond$data.generateDocumentUrl) === null || _respond$data$generat === void 0 ? void 0 : _respond$data$generat.url;
            var documentId = respond === null || respond === void 0 ? void 0 : (_respond$data2 = respond.data) === null || _respond$data2 === void 0 ? void 0 : (_respond$data2$genera = _respond$data2.generateDocumentUrl) === null || _respond$data2$genera === void 0 ? void 0 : _respond$data2$genera.documentId;
            var file = accepted[0];
            var params = {
              body: file,
              method: 'PUT',
              headers: {
                'Content-Type': file.type
              }
            };
            return Promise.resolve(fetch(signedUrl, params)).then(function () {
              return Promise.resolve(uploadDocument({
                documentId: documentId
              })).then(function () {});
            });
          });
        }, function () {
          setMessage(ERROR_MESSAGE);
        });
      }, function (_wasThrown, _result) {
        setLoading(false);
        if (_wasThrown) throw _result;
        return _result;
      });

      return Promise.resolve(_temp2 && _temp2.then ? _temp2.then(function () {}) : void 0);
    } catch (e) {
      return Promise.reject(e);
    }
  }, [generateDocumentUrl, uploadDocument, setLoading]);
  return {
    onDrop: onDrop,
    loading: loading,
    message: message
  };
}

var affiliatesStorageKey = 'aff';
var NUMBER_OF_DAYS_TO_SAVE_TOKEN = 14;

var getAffiliateTokenAndId = function getAffiliateTokenAndId(search) {
  var params = decodeQs(search);
  var affiliateToken = params.affiliateToken,
      affiliateId = params.affiliateId;
  return {
    token: affiliateToken,
    id: affiliateId
  };
};

function saveAffiliateParameters() {
  var _getAffiliateTokenAnd = getAffiliateTokenAndId(window.location.search),
      id = _getAffiliateTokenAnd.id,
      token = _getAffiliateTokenAnd.token;

  if (id && token) {
    localStorage.setItem(affiliatesStorageKey, JSON.stringify({
      id: id,
      token: token,
      savedAt: new Date()
    }));
  }
}

function getAffiliateParams() {
  if (typeof localStorage === 'undefined') {
    return null;
  }

  var _JSON$parse = JSON.parse(localStorage.getItem(affiliatesStorageKey) || '{}'),
      id = _JSON$parse.id,
      token = _JSON$parse.token,
      savedAt = _JSON$parse.savedAt;

  if (id && token && savedAt) {
    var expiresAt = new Date(savedAt).setDate(new Date(savedAt).getDate() + NUMBER_OF_DAYS_TO_SAVE_TOKEN);

    if (new Date(expiresAt) > new Date()) {
      return {
        token: token,
        id: id
      };
    }
  }

  return null;
}

function formatDate(date) {
  return date.toLocaleDateString();
}

function formatTime(date) {
  return date.toLocaleTimeString();
}

function internalFormatDate(date) {
  var d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();
  if (month.length < 2) month = '0' + month;
  if (day.length < 2) day = '0' + day;
  return [year, month, day].join('-');
}

function toFixed(amount, precision) {
  if (precision === void 0) {
    precision = 2;
  }

  var p = Math.pow(10, precision);
  return (Math.floor(amount * p) / p).toLocaleString(undefined, {
    minimumFractionDigits: precision,
    maximumFractionDigits: precision
  });
}

function formatAmount(_ref) {
  var amount = _ref.amount,
      currency = _ref.currency,
      precision = _ref.precision;
  return toFixed(amount, precision) + " " + (currency || '???');
}

function formatDateTime(date) {
  return (typeof date === 'string' ? new Date(date) : date).toLocaleString(undefined);
}

var GET_GEO = {
  "kind": "Document",
  "definitions": [{
    "kind": "OperationDefinition",
    "operation": "query",
    "name": {
      "kind": "Name",
      "value": "GetGeo"
    },
    "variableDefinitions": [],
    "directives": [],
    "selectionSet": {
      "kind": "SelectionSet",
      "selections": [{
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "viewer"
        },
        "arguments": [],
        "directives": [],
        "selectionSet": {
          "kind": "SelectionSet",
          "selections": [{
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "id"
            },
            "arguments": [],
            "directives": []
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "geoLocation"
            },
            "arguments": [],
            "directives": [],
            "selectionSet": {
              "kind": "SelectionSet",
              "selections": [{
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "countryCode"
                },
                "arguments": [],
                "directives": []
              }]
            }
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "countries"
            },
            "arguments": [],
            "directives": [],
            "selectionSet": {
              "kind": "SelectionSet",
              "selections": [{
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "id"
                },
                "arguments": [],
                "directives": []
              }, {
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "code"
                },
                "arguments": [],
                "directives": []
              }, {
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "name"
                },
                "arguments": [],
                "directives": []
              }, {
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "currency"
                },
                "arguments": [],
                "directives": []
              }]
            }
          }]
        }
      }]
    }
  }],
  "loc": {
    "start": 0,
    "end": 81,
    "source": {
      "body": "query GetGeo{viewer{id geoLocation{countryCode}countries{id code name currency}}}",
      "name": "GraphQL request",
      "locationOffset": {
        "line": 1,
        "column": 1
      }
    }
  }
};

var getCountries = function getCountries(countries, localizedCountries) {
  return countries.map(function (country) {
    var localizedCountry = localizedCountries ? localizedCountries.find(function (c) {
      return c.code === country.code;
    }) : null;
    return {
      key: country.code,
      value: country.code,
      text: localizedCountry ? localizedCountry.name : country.name,
      currency: country.currency
    };
  }).sort(function (a, b) {
    if (a.text > b.text) {
      return 1;
    }

    if (b.text > a.text) {
      return -1;
    }

    return 0;
  });
};

var useGeo = function useGeo() {
  var _useDinoQuery = useDinoQuery(GET_GEO, {
    onError: handleError()
  }),
      loading = _useDinoQuery.loading,
      data = _useDinoQuery.data,
      error = _useDinoQuery.error;

  var _useState = useState({
    countries: [],
    countryCode: undefined,
    countryCurrency: undefined,
    loading: true
  }),
      state = _useState[0],
      setState = _useState[1];

  useEffect(function () {
    if (!loading && !error) {
      var _data$viewer, _data$viewer$geoLocat, _countries$find;

      var countries = (data === null || data === void 0 ? void 0 : (_data$viewer = data.viewer) === null || _data$viewer === void 0 ? void 0 : _data$viewer.countries) || [];
      var countryCode = data === null || data === void 0 ? void 0 : (_data$viewer$geoLocat = data.viewer.geoLocation) === null || _data$viewer$geoLocat === void 0 ? void 0 : _data$viewer$geoLocat.countryCode;
      var countryCurrency = ((_countries$find = countries.find(function (country) {
        return country.code === countryCode;
      })) === null || _countries$find === void 0 ? void 0 : _countries$find.currency) || undefined;
      setState({
        countries: countries,
        countryCode: countryCode,
        countryCurrency: countryCurrency,
        loading: false
      });
    }
  }, [data, loading, error]);
  return state;
};

var useCountries = function useCountries(_ref) {
  var localizedCountries = _ref.localizedCountries;

  var _useGeo = useGeo(),
      loading = _useGeo.loading,
      countries = _useGeo.countries;

  return {
    loading: loading,
    countries: getCountries(countries || [], localizedCountries)
  };
};

var useCountryCode = function useCountryCode() {
  var _player$country;

  var _useGeo2 = useGeo(),
      loading = _useGeo2.loading,
      countryCode = _useGeo2.countryCode;

  var _useIsAuthenticated = useIsAuthenticated(),
      isLoggedIn = _useIsAuthenticated.isLoggedIn;

  var _usePlayerContext = usePlayerContext(),
      player = _usePlayerContext.player;

  var country = countryCode; //If the user is logged in we use his chosen country

  if (isLoggedIn && (player === null || player === void 0 ? void 0 : (_player$country = player.country) === null || _player$country === void 0 ? void 0 : _player$country.code)) {
    var _player$country2;

    country = player === null || player === void 0 ? void 0 : (_player$country2 = player.country) === null || _player$country2 === void 0 ? void 0 : _player$country2.code;
  }

  return {
    loading: loading,
    countryCode: country
  };
};

var getCurrentDevice = /*#__PURE__*/Array().concat.apply([], [!isTablet && !isMobile ? ['desktop'] : [], isMobileOnly && isIOS ? ['iphone'] : [], isTablet && isIOS ? ['ipad'] : [], isWinPhone ? ['winPhone'] : [], isAndroid && isTablet ? ['androidTablet'] : [], isAndroid && isMobileOnly ? ['androidPhone'] : []])[0] || 'desktop';

var replaceInText = function replaceInText(text, params) {
  var replaced = text;
  Object.keys(params).forEach(function (key) {
    replaced = replaced.replace(new RegExp("\\{\\{" + key + "\\}\\}", 'g'), params[key]);
  });
  return replaced;
};

var ParseTranslation = function ParseTranslation(_ref) {
  var translation = _ref.translation,
      params = _ref.params,
      component = _ref.component;

  if (!translation) {
    return '';
  }

  var C = component || 'div';

  if (params) {
    var danger_dom = React__default.createElement(C, {
      dangerouslySetInnerHTML: {
        __html: replaceInText(translation, params)
      }
    });
    translation = React__default.createElement(React__default.Fragment, null, danger_dom);
  }

  return translation;
};

var allowedUtms = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
var utmStorageKey = 'utm';

var filterValidUtms = function filterValidUtms(utms) {
  return Object.keys(utms).filter(function (k) {
    return allowedUtms.includes(k);
  }).reduce(function (o, k) {
    o[k] = utms[k];
    return o;
  }, {});
};

var utms = function utms(search) {
  var params = decodeQs(search);
  return filterValidUtms(params);
};

function saveUtmParameters() {
  if (!sessionStorage.getItem(utmStorageKey)) {
    sessionStorage.setItem(utmStorageKey, JSON.stringify(utms(window.location.search)));
  }
}

function getUtmParameters() {
  if (typeof sessionStorage === 'undefined') {
    return null;
  }

  var saved = JSON.parse(sessionStorage.getItem(utmStorageKey) || '{}');
  return saved.utm_source ? {
    utmSource: saved.utm_source,
    utmMedium: saved.utm_medium,
    utmCampaign: saved.utm_campaign,
    utmTerm: saved.utm_term,
    utmContent: saved.utm_content
  } : null;
}

export { ACCESS_TOKEN_COOKIE_NAME, AuthStatus, ConfigContext, DialogProvider, ErrorType, GAME_PLAY_STARTED_AT, LayoutProvider, LocaleContext, LogoutReason, NotificationTypes, ParseTranslation, PlayerContext, PlayerContextProvider, REFRESH_TOKEN_COOKIE_NAME, SessionLifecycle, TokenContext, TokenContextProvider, WalletContext, WalletContextProvider, WalletStatus, ZendeskProvider, addParamsToUrl, affiliatesStorageKey, dataToConfig, decodeQs, encodeQs, formatAmount, formatDate, formatDateTime, formatTime, getAccessToken, getAffiliateParams, getCurrentDevice, getCurrentQueryParams, getFirstGraphQLErrorType, getGraphQLErrorType, getMutationErrorMessage, getRefreshToken, getUtmParameters, handleError, hasError, internalFormatDate, refreshTokens, removeAccessToken, removeAccessTokens, removeRealityCheckTokens, removeRefreshToken, replaceInText, saveAffiliateParameters, saveUtmParameters, tokenExchange, updateAccessToken, updateRefreshToken, updateTokensFromQueryString, useAcceptTerms, useAccountNotifications, useCheckTerms, useConfigContext, useCountries, useCountryCode, useDialogContext, useDinoMutation, useDinoQuery, useDocumentUpload, useFetchJson, useGeo, useIsAuthenticated, useLastPlayedGames, useLayout, useLocale, useLogout, usePlayerContext, useRequiresAdditionalInfo, useScript, useSessionInfo, useSessionWagerActivity, useTimeout, useTimer, useTokenContext, useVerifyEmail, useWalletContext, useWindowSize, useZendeskContext, utmStorageKey };